import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {UserSettings} from './global/user-settings.dto';

@Injectable({
    providedIn: 'root'
})

export class AppService {
    constructor(private http:HttpClient) {
    }

    /**
     * fetch user all settings
     */
    settings() {
       return this.http.get<UserSettings>('settings',{});
    }
}
